import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BaseComponent from './BaseComponent';
import { clickButton } from '../../actions/Modal';
import Style from './ButtonList.cssmodule.less';
import Button from '../CommonSet/Button';
import Title from '../CommonSet/Title';

class ButtonList extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
    }

    getLang(key) {
        return this.Utils.getLang(key);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'BUTTON_LIST');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
        });
    }

    createContent(content) {
        let view = null;
        try {
            if (typeof content === 'object') {
                view = (
                    <div
                        className={`${this.Style.content}`}
                        dangerouslySetInnerHTML={{
                            __html: content.outerHTML,
                        }}
                    />
                );
            } else if (typeof content === 'string') {
                view = <div className={this.Style.content}>{content}</div>;
            }
        } catch (e) { }

        return view;
    }

    createButtonList(buttons) {
        if (Array.isArray(buttons) && buttons.length > 0) {
            const result = buttons.map((button, idx) => {
                return (
                    <Button
                        key={`button_${idx}`}
                        className={button.isAlter ? this.Style.alterButton : this.Style.button}
                        text={button.text}
                        onClick={(e) => button.click(e)}
                        style={button.style}
                    />
                );
            });

            return <div className={this.Style.buttonGroup}>{result}</div>;
        }

        return null;
    }

    render() {
        const {
            title,
            content,
            buttons = [
                {
                    isAlter: false,
                    text: '',
                    click: () => { },
                    style: {},
                }
            ]
        } = this.props.item;

        return (
            <div className={this.Style.buttonList}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {title}
                </Title>
                <div className={this.Style.contentView}>
                    {this.createContent(content)}
                    {this.createButtonList(buttons)}
                </div>
            </div>
        );
    }
}

ButtonList.displayName = 'ButtonList';
ButtonList.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    return { actions: bindActionCreators(actions, dispatch) };
}

export default connect(
    undefined,
    mapDispatchToProps
)(ButtonList);



// WEBPACK FOOTER //
// ./components/ModalSet/ButtonList.js